import ReactOnRails from 'react-on-rails/client';
import FindAContractorListing from '../../components/ror_components/FindAContractorListing.jsx';

ReactOnRails.register({FindAContractorListing});